export function formatter(symbol: string, scale = 100) {
  if (scale <= 0) throw new RangeError('scale must be positive!');

  const regex = new RegExp(`(${symbol})`);
  return {
    regexps: {
      format: regex,
      unformat: regex,
    },
    format(num: number) {
      return `${num * scale}${symbol}`;
    },
    unformat(str: string) {
      const numberAsString = str.substring(0, str.lastIndexOf(symbol));
      return +numberAsString * (1 / scale);
    },
  };
}
